<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <MisPedidos></MisPedidos>
</v-col>
</v-row>
</v-container>
</div>
</template>

<script>
import MisPedidos from '@/components/tienda/pedido/MisPedidos.vue';

export default {
  data() {
    return {}
  },
  components: {
    MisPedidos
  },
  methods: {}
}
</script>
